import {useCallback} from 'react';

const useCheckTelegramId = () => {
    const baseUrl = process.env.REACT_APP_API_TELEGRAM_ID_CHECK_URL;
    const auth = process.env.REACT_APP_API_TELEGRAM_ID_CHECK_AUTH;

    const checkTelegramId = useCallback(async (telegramId) => {
        if (!telegramId || typeof telegramId !== 'string') {
            console.error('Invalid telegramId provided');
            return {
                isAuthorized: false,
                brand: 'unknown',
            };
        }

        try {
            const url = new URL(baseUrl);
            url.pathname = url.pathname + telegramId;

            const response = await fetch(url.toString(), {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${auth}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                console.error('Failed to check telegram ID:', response.status);
                return {
                    isAuthorized: false,
                    brand: 'unknown',
                };
            }

            const data = await response.json();

            return {
                isAuthorized: data.authorization === true,
                brand: data.brend,
            };

        } catch (error) {
            console.error('Error checking telegram ID:', error);
            return {
                isAuthorized: false,
                brand: 'unknown',
            };
        }
    }, []);

    return { checkTelegramId };
};

export default useCheckTelegramId;
